// Copyright (c) StrangeBee 2023

import { DescribeOutput, QuerySelector, TaskStatus } from 'thehive-sdk';

interface GetSelectorParams {
    taskId: string;
}

export const computeGetSelector = ({ taskId }: GetSelectorParams): QuerySelector => ({
    head: [{ name: 'getTask', idOrName: taskId }],
    extraData: ['actionRequired', 'actionRequiredMap', 'case', 'logCount'],
    name: `get-task-details-${taskId}`,
});

interface ListSelectorParams {
    caseId: string;
    describeData?: DescribeOutput;
}

export const computeListSelector = ({ caseId, describeData }: ListSelectorParams): QuerySelector => ({
    head: [{ name: 'getCase', idOrName: caseId }, { name: 'tasks' }],
    extraData: ['actionRequired', 'shareCount', 'logCount', 'case'],
    name: `get-case-tasks-${caseId}`,
    initialFilters: [
        {
            field: 'status',
            operator: 'not',
            values: [TaskStatus.CANCEL],
            type: 'string',
            describeAttribute: describeData?.task.attributes?.find(({ name }) => name === 'status') as any,
        },
    ],
    sort: ['+order'],
});
